export default class StatType {
    static MemberCount = "memberCount";
    static RegistrationCount = "registrationCount";
    static SuggestionCount = "suggestionCount";
}